import { createFileRoute } from "@tanstack/react-router";
import { Assets } from "@/components/Assets";

function RouteComponent() {
  return <Assets />;
}

export const Route = createFileRoute("/_authenticated/assets/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
